import { FormControlLabel, Radio, RadioGroup } from "@mui/material"
import React from "react"
import { context } from "../.."


export default function FieldRadio ({formik, field, disabled = false, autoFocus = false}) {

    const label = context.formatLabel(field.label)

    return (
        <div className="form-field field-radio-select">
            {label ? <span>{label}</span> : null}
            
            {field.helpText ? <span className="help-text" style={{marginTop: "4px"}}>{field.helpText}</span> : null}
            
            <RadioGroup
                name={field.name}
                value={formik.values[field.name]}
                style={{margin: "10px 0 0 15px"}}
                onChange={formik.handleChange}>

                {field.options && typeof field.options === 'object' && Object.keys(field.options).map((key, i) => {
                    var label = context.formatLabel(field.options[key])
                    // Don't show options with placeholders remaining
                    if (label.includes("{") || label.includes("}")) {
                        return <React.Fragment key={i}></React.Fragment>
                    }
                    
                    return (
                        <FormControlLabel
                            key={i}
                            value={key}
                            label={label} 
                            disabled={disabled}
                            control={
                                // Apply autoFocus to the first option
                                <Radio inputProps={{autoFocus: i === 0 ? autoFocus : false}} />
                            } />
                    )
                })}
            </RadioGroup>
        </div>
    )
}